import { render, staticRenderFns } from "./AdminLK.vue?vue&type=template&id=57b761d1&"
import script from "./AdminLK.vue?vue&type=script&lang=js&"
export * from "./AdminLK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports